import { usePageSeo } from "@/hooks/usePageSeo";
import HeroSection from "@/components/HeroSection";
import FeaturedToursSection from "@/components/FeaturedToursSection";
import AboutSnippet from "@/components/AboutSnippet";
import FleetSection from "@/components/FleetSection";
import FeaturesSection from "@/components/FeaturesSection";
import ServicesSection from "@/components/ServicesSection";
import StatsSection from "@/components/StatsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";

const Index = () => {
  usePageSeo("home");
  return (
    <main>
      <HeroSection />
      <FeaturedToursSection />
      <AboutSnippet />
      <FleetSection />
      <FeaturesSection />
      <ServicesSection />
      <StatsSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </main>
  );
};

export default Index;
